var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackAndSupportSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#febe10;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback_and_support_support"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.35.76C135.57.76,1.78,133.36.36,298.12A298.71,298.71,0,0,0,35.9,442.5,30.14,30.14,0,0,1,38.12,466L2.94,575.86a18.64,18.64,0,0,0,23.43,23.43l110.48-35.38a30.13,30.13,0,0,1,23.32,2.14A300.08,300.08,0,0,0,600.35,300.76C600.35,135.08,466,.76,300.35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.94,155.58h0C401.26,139.35,386,126.37,366.54,117c-19.28-9.29-41.73-14-66.74-14-26.94,0-50.92,5.64-71.27,16.77s-36.12,25.46-46.81,42.56-16.21,34.49-16.21,51.44c0,9.31,3.84,18,11.39,25.71A37.83,37.83,0,0,0,205,251.23c12.92,0,30-5.65,38.17-32.58,5.69-17,12.63-30,20.64-38.56,7.41-7.91,19.53-11.93,36-11.93,14.2,0,25.39,4,34.21,12.12s12.9,17.59,12.9,29.24a32,32,0,0,1-4.1,16,65.67,65.67,0,0,1-11,14.53c-4.62,4.62-12.31,11.64-22.84,20.86A401.77,401.77,0,0,0,279.5,289a98.85,98.85,0,0,0-18.42,28.81c-4.64,11-7,24-7,38.82,0,12.88,3.63,22.88,10.78,29.73s15.89,10.23,26.18,10.23c19.7,0,32.09-10.71,35.83-31,1.8-8,3.15-13.6,4-16.7a47.21,47.21,0,0,1,3.43-8.61,49.56,49.56,0,0,1,6.79-9.52,168.88,168.88,0,0,1,13.1-13.09c20.46-18.29,34.88-31.53,42.86-39.35a120.65,120.65,0,0,0,21.64-29.13c6.22-11.53,9.37-25.06,9.37-40.21A95.84,95.84,0,0,0,411.94,155.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.72,424.66A43.35,43.35,0,1,0,340.07,468,43.39,43.39,0,0,0,296.72,424.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAndSupportSupport);
export default __webpack_public_path__ + "static/media/feedback_and_support_support.0c0b12bdfca1fc4702dcd41fdae4c499.svg";
export { ForwardRef as ReactComponent };